import { computed, watch } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { useApi } from '@shopexperts/shared';

export function useAdminProjectValueRanges() {
  const api = useApi();

  const { data, isLoading, isFetching, error, refetch } = useQuery({
    queryKey: ['admin', 'project-value-ranges'],
    queryFn: () => api.admin.reviewsV2.getProjectValueRanges(),
    staleTime: 60 * 60 * 1000,
    gcTime: 24 * 60 * 60 * 1000,
  });

  watch(error, (newError) => {
    if (newError) {
      console.error('[useAdminProjectValueRanges] Error:', newError);
    }
  });

  return {
    ranges: computed(() => data.value ?? []),
    isLoadingRanges: computed(() => isLoading.value || isFetching.value),
    rangesError: computed(() => error.value),
    retryRanges: refetch,
  };
}
